import { createFileRoute } from "@tanstack/react-router";
import { getRouterInstance } from "@tanstack/react-start";
import { articleDetails } from "@/data/article-content";
import { cityPages } from "@/data/city-pages";
import { tradePages } from "@/data/trade-pages";
import { agentServices, directoryRegions, directoryTrades } from "@/data/directory-pages";
import { regionalServices } from "@/data/regional-services";
import { regionalServiceSlug } from "@/lib/regional-services";
import {
  isSitemapRouteIncluded,
  sitemapPathForLocation,
  sitemapStaticPaths,
  sitemapXML,
  type SitemapEntry,
} from "@/lib/sitemap";

const BASE_URL = "https://begner.ch";

export const Route = createFileRoute("/sitemap.xml")({
  staticData: { sitemap: false },
  server: {
    handlers: {
      GET: async () => {
        const router = await getRouterInstance();
        const entries: SitemapEntry[] = sitemapStaticPaths(router).map((path) => ({ path }));
        const appendDynamicPath = (routeId: string, path: string) => {
          const location = router.buildLocation({
            to: path,
            search: () => ({}),
            hash: "",
          });
          const sitemapPath = sitemapPathForLocation(router, location, routeId);
          if (sitemapPath) entries.push({ path: sitemapPath });
        };
        const articleRouteId = "/artikel/$slug";
        if (isSitemapRouteIncluded(router.routesById[articleRouteId])) {
          for (const article of articleDetails) {
            const location = router.buildLocation({
              to: "/artikel/$slug",
              params: { slug: article.slug },
              search: () => ({}),
              hash: "",
            });
            const path = sitemapPathForLocation(router, location, articleRouteId);
            if (path) entries.push({ path });
          }
        }
        for (const city of cityPages) {
          appendDynamicPath("/handwerker/$stadt", `/handwerker/${city.slug}`);
          appendDynamicPath("/immobilie-verkaufen/$stadt", `/immobilie-verkaufen/${city.slug}`);
        }
        for (const city of cityPages) {
          for (const trade of tradePages) {
            appendDynamicPath(
              "/handwerker/$stadt_/$gewerk",
              `/handwerker/${city.slug}/${trade.slug}`,
            );
          }
        }
        for (const trade of tradePages) {
          appendDynamicPath("/gewerke/$gewerk", `/gewerke/${trade.slug}`);
        }
        for (const region of directoryRegions) {
          for (const service of regionalServices) {
            appendDynamicPath("/$serviceRegion", `/${regionalServiceSlug(service, region)}`);
          }
          appendDynamicPath(
            "/handwerkerverzeichnis/$region",
            `/handwerkerverzeichnis/${region.slug}`,
          );
          appendDynamicPath("/makler_/$region", `/makler/${region.slug}`);
        }
        for (const trade of directoryTrades) {
          appendDynamicPath(
            "/handwerkerverzeichnis/gewerk/$gewerk",
            `/handwerkerverzeichnis/gewerk/${trade.slug}`,
          );
        }
        for (const service of agentServices) {
          appendDynamicPath("/makler_/leistungen/$leistung", `/makler/leistungen/${service.slug}`);
        }
        return new Response(sitemapXML(BASE_URL, entries), {
          headers: { "Content-Type": "application/xml", "Cache-Control": "public, max-age=3600" },
        });
      },
    },
  },
});
